// src/config/feeds.js

// Saved feed definition - added to all countries
const SAVED_FEED = {
  id: 'saved',
  title: 'Saved',
  uri: null,
  icon: '🔖'
};

export const COUNTRIES = {
	AU: {
		id: 'AU',
		name: 'Australia',
		flag: '🇦🇺',
		govDomains: ['.gov.au'],
		feeds: {
		  recent: {
			id: 'recent',
			title: 'Recent',
			uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaapa25vr3bti',
			icon: '🕒'
		  },
		  trending: {
			id: 'trending',
			title: 'Trending',
			uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaapa3pz3hdag',
			icon: '🔥'
		  },
		  officials: {
			id: 'officials',
			title: 'Officials',
			uri: '',
			icon: '👥'
		  }
		}
	  },
	  BR: {
		id: 'BR',
		name: 'Brazil',
		flag: '🇧🇷',
		govDomains: ['.gov.br'],
		feeds: {
		  recent: {
			id: 'recent',
			title: 'Recent',
			uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaaorhenjmmmm',
			icon: '🕒'
		  },
		  trending: {
			id: 'trending',
			title: 'Trending',
			uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaaorhvv6pgtw',
			icon: '🔥'
		  },
		  officials: {
			id: 'officials',
			title: 'Officials',
			uri: '',
			icon: '👥'
		  }
		}
	  },
	  CA: {
		  id: 'CA',
		  name: 'Canada',
		  flag: '🇨🇦',
		  govDomains: ['.gc.ca', '.canada.ca'],
		  feeds: {
			recent: {
			  id: 'recent',
			  title: 'Recent',
			  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaan4yosuex6i',
			  icon: '🕒'
			},
			trending: {
			  id: 'trending',
			  title: 'Trending',
			  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaan42tbcgbik',
			  icon: '🔥'
			},
			officials: {
			  id: 'officials',
			  title: 'Officials',
			  uri: '',
			  icon: '👥'
			}
		  }
		},
		CH: {
			id: 'CH',
			name: 'China',
			flag: '🇨🇳',
			govDomains: ['.gov.cn'],
			feeds: {
			  recent: {
				id: 'recent',
				title: 'Recent',
				uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaapay4jegzdy',
				icon: '🕒'
			  },
			  trending: {
				id: 'trending',
				title: 'Trending',
				uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaapazm2vhhb2',
				icon: '🔥'
			  },
			  officials: {
				id: 'officials',
				title: 'Officials',
				uri: '',
				icon: '👥'
			  }
			}
		  },
		  GE: {
			  id: 'GE',
			  name: 'Germany',
			  flag: '🇩🇪',
			  govDomains: ['.bund.de', '.gov.de'],
			  feeds: {
				recent: {
				  id: 'recent',
				  title: 'Recent',
				  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaapay4jegzdy',
				  icon: '🕒'
				},
				trending: {
				  id: 'trending',
				  title: 'Trending',
				  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaapeukwokt56',
				  icon: '🔥'
				},
				officials: {
				  id: 'officials',
				  title: 'Officials',
				  uri: '',
				  icon: '👥'
				}
			  }
			},
		  JP: {
			  id: 'JP',
			  name: 'Japan',
			  flag: '🇯🇵',
			  govDomains: ['.go.jp'],
			  feeds: {
				recent: {
				  id: 'recent',
				  title: 'Recent',
				  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaapavcejdpdi',
				  icon: '🕒'
				},
				trending: {
				  id: 'trending',
				  title: 'Trending',
				  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaapavqlujysg',
				  icon: '🔥'
				},
				officials: {
				  id: 'officials',
				  title: 'Officials',
				  uri: '',
				  icon: '👥'
				}
			  }
			},
			SI: {
			  id: 'SI',
			  name: 'Singapore',
			  flag: '🇸🇬',
			  govDomains: ['.gov.sg'],
			  feeds: {
				recent: {
				  id: 'recent',
				  title: 'Recent',
				  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaapaxynmkodi',
				  icon: '🕒'
				},
				trending: {
				  id: 'trending',
				  title: 'Trending',
				  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaapayjugqcse',
				  icon: '🔥'
				},
				officials: {
				  id: 'officials',
				  title: 'Officials',
				  uri: '',
				  icon: '👥'
				}
			  }
			},
		  
			SP: {
			  id: 'SP',
			  name: 'Spain',
			  flag: '🇪🇸',
			  govDomains: ['.gob.es'],
			  feeds: {
				recent: {
				  id: 'recent',
				  title: 'Recent',
				  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaaozx2ncypbc',
				  icon: '🕒'
				},
				trending: {
				  id: 'trending',
				  title: 'Trending',
				  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaaozy5rghwva',
				  icon: '🔥'
				},
				officials: {
				  id: 'officials',
				  title: 'Officials',
				  uri: '',
				  icon: '👥'
				}
			  }
			},
	  UK: {
		  id: 'UK',
		  name: 'United Kingdom',
		  flag: '🇬🇧',
		  govDomains: ['.gov.uk'],
		  feeds: {
			recent: {
			  id: 'recent',
			  title: 'Recent',
			  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaan4x3vnihd2',
			  icon: '🕒'
			},
			trending: {
			  id: 'trending',
			  title: 'Trending',
			  uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaan43in3o4bq',
			  icon: '🔥'
			},
			officials: {
			  id: 'officials',
			  title: 'Officials',
			  uri: '',
			  icon: '👥'
			}
		  }
		},
  US: {
    id: 'US',
    name: 'United States',
    flag: '🇺🇸',
    govDomains: ['.gov', '.mil'],
    feeds: {
      recent: {
        id: 'recent',
        title: 'Recent',
        uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaap7i2f6e3kq',
        icon: '🕒'
      },
      trending: {
        id: 'trending',
        title: 'Trending',
        uri: 'at://did:plc:hd4p7hmwqy3egilcv6lgjpzf/app.bsky.feed.generator/aaalqajsyf622',
        icon: '🔥'
      },
      officials: {
        id: 'officials',
        title: 'Officials',
        uri: 'at://did:plc:pe365hgnkisv4rhrcow7m5ue/app.bsky.feed.generator/aaad23xoo2t4y',
        icon: '👥'
      }
    }
  },
};

// Add saved feed to all countries
Object.values(COUNTRIES).forEach(country => {
  country.feeds.saved = SAVED_FEED;
});